export const TypeOfChanges = [
  "Game",
  "Kernel",
  "Version",
  "Ownership",
  "Location Transfer",
];
